export default "__VITE_ASSET__Dl89b9JB__"